/**
 * Sample request modal: opens from .ebx-sample-modal-trigger when popup is enabled.
 * Trigger attributes: handle, name/title, category, type, potency, status, batch-date (data-product-*). Source page URL uses window.location.href when the modal opens.
 * HubSpot embed: product context is applied to matching inputs by HTML name (see section field map).
 * HSFC RichText: theme CSS cannot pierce shadow DOM—richtext rules are injected into open shadow roots under the popup.
 */
(function () {
  var root = document.getElementById('ebx-sample-popup-root');
  if (!root) return;

  var enabled = root.getAttribute('data-ebx-sample-popup-enabled') === 'true';
  var lastFocus = null;
  var prefillTimer = null;
  var hubspotShadowInjectTimer = null;
  var hubspotShadowObserver = null;

  /**
   * HubSpot HSFC renders inside closed/open shadow trees; page CSS cannot target .hsfc-RichText.
   * Inject equivalent rules into each shadow root that contains HubSpot UI under the popup.
   */
  var HSFC_RICHTEXT_SHADOW_CSS =
    '.hsfc-RichText{color:#f5f1ea!important}' +
    '.hsfc-RichText p{' +
    'font-family:var(--body-font,Epilogue,sans-serif)!important;' +
    'font-style:normal!important;font-weight:400!important;' +
    'text-decoration:none!important;color:#f5f1ea!important;font-size:14px!important' +
    '}' +
    '.hsfc-RichText a{color:#f5f1ea!important}';

  var HSFC_SHADOW_STYLE_CLASS = 'ebx-sample-popup-hsfc-rich-text-style';

  function injectHubspotRichTextStyleInShadow(shadowRoot) {
    if (!shadowRoot || typeof shadowRoot.querySelector !== 'function') return;
    if (shadowRoot.querySelector('style.' + HSFC_SHADOW_STYLE_CLASS)) return;
    if (!shadowRoot.querySelector('.hsfc-RichText, [class*="hsfc-"]')) return;
    var doc = shadowRoot.ownerDocument || document;
    var st = doc.createElement('style');
    st.className = HSFC_SHADOW_STYLE_CLASS;
    st.setAttribute('data-ebx-hsfc', 'richtext');
    st.textContent = HSFC_RICHTEXT_SHADOW_CSS;
    shadowRoot.appendChild(st);
  }

  function walkShadowRootsAndInject(start) {
    if (!start) return;
    function visit(node) {
      if (!node || node.nodeType !== 1) return;
      if (node.shadowRoot) {
        try {
          injectHubspotRichTextStyleInShadow(node.shadowRoot);
        } catch (e0) {}
        var c0 = node.shadowRoot.firstElementChild;
        while (c0) {
          visit(c0);
          c0 = c0.nextElementSibling;
        }
      }
      var c = node.firstElementChild;
      while (c) {
        visit(c);
        c = c.nextElementSibling;
      }
    }
    visit(start);
  }

  function injectHubspotShadowStylesUnder(container) {
    if (!container || container.nodeType !== 1) return;
    walkShadowRootsAndInject(container);
  }

  function injectHubspotShadowStylesInPopup() {
    if (!root || root.hidden) return;
    injectHubspotShadowStylesUnder(root);
    var iframes = root.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      try {
        var idoc = iframes[i].contentDocument;
        if (idoc && idoc.documentElement) {
          walkShadowRootsAndInject(idoc.documentElement);
        }
      } catch (e1) {}
    }
  }

  function scheduleInjectHubspotShadowStyles() {
    if (hubspotShadowInjectTimer) return;
    hubspotShadowInjectTimer = setTimeout(function () {
      hubspotShadowInjectTimer = null;
      injectHubspotShadowStylesInPopup();
    }, 0);
  }

  function ensureHubspotShadowStyleObserver() {
    if (hubspotShadowObserver || !root) return;
    try {
      hubspotShadowObserver = new MutationObserver(function () {
        scheduleInjectHubspotShadowStyles();
      });
      hubspotShadowObserver.observe(root, { childList: true, subtree: true });
    } catch (e2) {}
  }
  ensureHubspotShadowStyleObserver();

  var hubspotPrefill = {
    handle: '',
    name: '',
    category: '',
    type: '',
    potency: '',
    status: '',
    batchDate: '',
    sourcePageUrl: ''
  };

  function getPanel() {
    return root.querySelector('.ebx-sample-popup__panel');
  }

  function getHubspotFieldMap() {
    var el = document.getElementById('ebx-hubspot-product-field-map');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return {};
    }
  }

  function hasPrefillPayload() {
    var p = hubspotPrefill;
    return !!(
      p.handle ||
      p.name ||
      p.category ||
      p.type ||
      p.potency ||
      p.status ||
      p.batchDate ||
      p.sourcePageUrl
    );
  }

  /** One line for a single HubSpot field (e.g. “products” textarea). */
  function buildProductSummaryLine(p) {
    var parts = [];
    if (p.handle) parts.push('Handle: ' + p.handle);
    if (p.name) parts.push('Title: ' + p.name);
    if (p.category) parts.push('Category: ' + p.category);
    if (p.type) parts.push('Type: ' + p.type);
    if (p.potency) parts.push('Potency: ' + p.potency);
    if (p.status) parts.push('Status: ' + p.status);
    if (p.batchDate) parts.push('Batch date: ' + p.batchDate);
    if (p.sourcePageUrl) parts.push('Source page: ' + p.sourcePageUrl);
    return parts.join(' | ');
  }

  function getHubSpotV4Form(messageEvent) {
    var HS = window.HubSpotFormsV4;
    if (!HS) return null;
    try {
      if (messageEvent && typeof HS.getFormFromEvent === 'function') {
        var fromEv = HS.getFormFromEvent(messageEvent);
        if (fromEv) return fromEv;
      }
    } catch (e1) {}
    try {
      if (typeof HS.getForms !== 'function') return null;
      var forms = HS.getForms();
      if (!forms || !forms.length) return null;
      var exp = normalizeGuid(root.getAttribute('data-ebx-hubspot-form-id'));
      for (var i = 0; i < forms.length; i++) {
        var fi = forms[i];
        var fid = fi && (fi.formId || fi.id || fi.guid);
        if (!exp || normalizeGuid(String(fid || '')) === exp) {
          return fi;
        }
      }
      return forms[0];
    } catch (e2) {
      return null;
    }
  }

  /** HSFC / cross-origin embeds: use HubSpot’s JS API (see global form events docs). */
  function applyPrefillHubSpotFormsV4(messageEvent) {
    if (!hasPrefillPayload()) return false;
    var form = getHubSpotV4Form(messageEvent);
    if (!form || typeof form.setFieldValue !== 'function') return false;
    var map = getHubspotFieldMap();
    var p = hubspotPrefill;
    function setField(name, val) {
      if (!name || val == null || val === '') return;
      try {
        var ret = form.setFieldValue(String(name), String(val));
        if (ret && typeof ret.then === 'function') {
          ret.catch(function () {});
        }
      } catch (e) {}
    }
    if (map.handle && p.handle) setField(map.handle, p.handle);
    if (map.name && p.name) setField(map.name, p.name);
    if (map.category && p.category) setField(map.category, p.category);
    if (map.type && p.type) setField(map.type, p.type);
    if (map.potency && p.potency) setField(map.potency, p.potency);
    if (map.status && p.status) setField(map.status, p.status);
    if (map.batchDate && p.batchDate) setField(map.batchDate, p.batchDate);
    if (map.sourcePageUrl && p.sourcePageUrl) setField(map.sourcePageUrl, p.sourcePageUrl);
    var summary = buildProductSummaryLine(p);
    if (map.productsSummary && summary) {
      setField(map.productsSummary, summary);
    }
    return true;
  }

  function normalizeGuid(s) {
    return String(s || '')
      .replace(/-/g, '')
      .toLowerCase();
  }

  function hubspotFormMatches(meta) {
    var expected = normalizeGuid(root.getAttribute('data-ebx-hubspot-form-id'));
    if (!expected) return true;
    var incoming = normalizeGuid(
      (meta && (meta.formId || meta.formGuid || meta.guid)) || ''
    );
    return incoming && incoming === expected;
  }

  /** HubSpot contact fields use names like "0-1/product_type" or "0-1/product_potency" (objectTypeId / property internal name). */
  function hubspotNameCandidates(nameAttr) {
    var n = String(nameAttr || '').trim();
    if (!n) return [];
    var out = [n];
    if (!/^\d+-\d+\//.test(n)) {
      out.push('0-1/' + n);
    }
    return out;
  }

  /** Walk light DOM + open shadow roots (HSFC embeds may host inputs inside components). */
  function getAllFormControls(container) {
    var out = [];
    function visit(node) {
      if (!node || node.nodeType !== 1) return;
      var tag = node.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
        out.push(node);
      }
      if (node.shadowRoot) {
        var s = node.shadowRoot.firstElementChild;
        while (s) {
          visit(s);
          s = s.nextElementSibling;
        }
      }
      var c = node.firstElementChild;
      while (c) {
        visit(c);
        c = c.nextElementSibling;
      }
    }
    if (container && container.nodeType === 9) {
      if (container.documentElement) visit(container.documentElement);
    } else if (container) {
      visit(container);
    }
    return out;
  }

  function findFieldByNameIn(container, nameAttr) {
    if (!container || !nameAttr) return null;
    var candidates = hubspotNameCandidates(nameAttr);
    if (!candidates.length) return null;
    var controls = getAllFormControls(container);
    for (var i = 0; i < controls.length; i++) {
      var nm = controls[i].getAttribute('name');
      if (!nm) continue;
      for (var c = 0; c < candidates.length; c++) {
        if (nm === candidates[c]) return controls[i];
      }
    }
    return null;
  }

  function dispatchFieldEvents(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    try {
      el.dispatchEvent(new Event('blur', { bubbles: true }));
    } catch (e) {}
  }

  function setElementValue(el, value) {
    var str = String(value);
    var tag = el.tagName;
    var win =
      el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : window;
    if (tag === 'INPUT' || tag === 'TEXTAREA') {
      var proto = tag === 'INPUT' ? win.HTMLInputElement.prototype : win.HTMLTextAreaElement.prototype;
      var desc = Object.getOwnPropertyDescriptor(proto, 'value');
      if (desc && desc.set) {
        desc.set.call(el, str);
      } else {
        el.value = str;
      }
    } else {
      el.value = str;
    }
  }

  function setFieldValueIn(container, nameAttr, value) {
    if (value == null || value === '' || !nameAttr) return false;
    var el = findFieldByNameIn(container, nameAttr);
    if (!el) return false;
    setElementValue(el, value);
    dispatchFieldEvents(el);
    return true;
  }

  function applyPrefillToContainer(container) {
    if (!container) return 0;
    var map = getHubspotFieldMap();
    var p = hubspotPrefill;
    var n = 0;
    if (map.handle && p.handle && setFieldValueIn(container, map.handle, p.handle)) n++;
    if (map.name && p.name && setFieldValueIn(container, map.name, p.name)) n++;
    if (map.category && p.category && setFieldValueIn(container, map.category, p.category)) n++;
    if (map.type && p.type && setFieldValueIn(container, map.type, p.type)) n++;
    if (map.potency && p.potency && setFieldValueIn(container, map.potency, p.potency)) n++;
    if (map.status && p.status && setFieldValueIn(container, map.status, p.status)) n++;
    if (map.batchDate && p.batchDate && setFieldValueIn(container, map.batchDate, p.batchDate)) n++;
    if (map.sourcePageUrl && p.sourcePageUrl && setFieldValueIn(container, map.sourcePageUrl, p.sourcePageUrl)) n++;
    var summary = buildProductSummaryLine(p);
    if (map.productsSummary && summary && setFieldValueIn(container, map.productsSummary, summary)) n++;
    return n;
  }

  function tryPrefillHubspotIframes(messageEvent) {
    scheduleInjectHubspotShadowStyles();
    if (!root.hidden && hasPrefillPayload()) {
      applyPrefillHubSpotFormsV4(messageEvent || null);
    }
    var total = applyPrefillToContainer(root);
    var iframes = root.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      try {
        var idoc = iframes[i].contentDocument;
        if (idoc) {
          total += applyPrefillToContainer(idoc);
          var nested = idoc.querySelectorAll('iframe');
          for (var j = 0; j < nested.length; j++) {
            try {
              var inner = nested[j].contentDocument;
              if (inner) total += applyPrefillToContainer(inner);
            } catch (e2) {}
          }
        }
      } catch (e) {}
    }
    return total;
  }

  function clearPrefillTimer() {
    if (prefillTimer) {
      clearInterval(prefillTimer);
      prefillTimer = null;
    }
  }

  function scheduleHubSpotPrefill() {
    clearPrefillTimer();
    var attempts = 0;
    var maxAttempts = 45;
    tryPrefillHubspotIframes(null);
    prefillTimer = setInterval(function () {
      attempts++;
      tryPrefillHubspotIframes(null);
      if (attempts >= maxAttempts) clearPrefillTimer();
    }, 200);
  }

  function onWindowMessage(event) {
    var d = event.data;
    if (d == null) return;
    if (typeof d === 'string') {
      try {
        d = JSON.parse(d);
      } catch (e) {
        return;
      }
    }
    if (typeof d !== 'object') return;
    var isCb = d.type === 'hsFormCallback' || d.eventType === 'hsFormCallback';
    if (!isCb || d.eventName !== 'onFormReady') return;
    var meta = d.data || d;
    if (!hubspotFormMatches(meta)) return;
    // HubSpot often fires onFormReady while the popup is still hidden; prefill only when the modal is open
    // so hubspotPrefill is already set from the trigger click.
    if (root.hidden) return;
    tryPrefillHubspotIframes(event);
  }

  window.addEventListener('message', onWindowMessage);

  /**
   * Reads data-product-* from the trigger node and any descendants (class on wrapper, attrs on child).
   */
  function fillFromTrigger(el) {
    if (!el || el.nodeType !== 1) return;
    var nodes = [el];
    try {
      nodes = nodes.concat(
        Array.from(
          el.querySelectorAll(
            '[data-product-handle],[data-product-name],[data-product-title],[data-product-category],[data-product-type],[data-product-potency],[data-product-status],[data-product-batch-date]'
          )
        )
      );
    } catch (e) {}
    var handle = '';
    var name = '';
    var category = '';
    var type = '';
    var potency = '';
    var status = '';
    var batchDate = '';
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!handle && n.getAttribute('data-product-handle')) {
        handle = n.getAttribute('data-product-handle') || '';
      }
      if (!name) {
        name = n.getAttribute('data-product-name') || n.getAttribute('data-product-title') || '';
      }
      if (!category && n.getAttribute('data-product-category')) {
        category = n.getAttribute('data-product-category') || '';
      }
      if (!type && n.getAttribute('data-product-type')) {
        type = n.getAttribute('data-product-type') || '';
      }
      if (!potency && n.getAttribute('data-product-potency')) {
        potency = n.getAttribute('data-product-potency') || '';
      }
      if (!status && n.getAttribute('data-product-status')) {
        status = n.getAttribute('data-product-status') || '';
      }
      if (!batchDate && n.getAttribute('data-product-batch-date')) {
        batchDate = n.getAttribute('data-product-batch-date') || '';
      }
    }
    hubspotPrefill.handle = handle;
    hubspotPrefill.name = name;
    hubspotPrefill.category = category;
    hubspotPrefill.type = type;
    hubspotPrefill.potency = potency;
    hubspotPrefill.status = status;
    hubspotPrefill.batchDate = batchDate;
  }

  function openModal(triggerEl) {
    if (triggerEl) {
      fillFromTrigger(triggerEl);
    }
    hubspotPrefill.sourcePageUrl =
      typeof window !== 'undefined' && window.location && window.location.href
        ? String(window.location.href)
        : '';
    root.hidden = false;
    document.body.classList.add('ebx-sample-popup-open');
    var panel = getPanel();
    if (panel) {
      panel.focus();
    }
    scheduleHubSpotPrefill();
  }

  function closeModal() {
    clearPrefillTimer();
    root.hidden = true;
    document.body.classList.remove('ebx-sample-popup-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
    lastFocus = null;
  }

  function resolveClickTargetEl(t) {
    if (!t) return null;
    if (t.nodeType === 3) return t.parentElement;
    return t.nodeType === 1 ? t : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!enabled) return;
      var el = resolveClickTargetEl(e.target);
      if (!el || typeof el.closest !== 'function') return;
      var trigger = el.closest('.ebx-sample-modal-trigger');
      if (!trigger) return;
      e.preventDefault();
      lastFocus = trigger;
      openModal(trigger);
    },
    true
  );

  root.addEventListener('click', function (e) {
    if (e.target.closest('.js-ebx-sample-close')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) {
      closeModal();
    }
  });
})();
